import React from 'react';
import { DashboardCard } from './DashboardCard';
import { TruckIcon, PackageIcon, WarehouseIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon, ArrowUpIcon, ArrowDownIcon, BarChart3Icon, DollarSignIcon, FilterIcon, ArrowUpDownIcon, GlobeIcon } from 'lucide-react';
export function OrdersOverview() {
  // Mock data
  const orderStats = {
    active: 22,
    value: '$2,272,301.43',
    margin: '20.78%',
    pending: {
      approval: 4,
      acknowledgment: 11,
      stock: 0,
      readyToLoad: 0,
      loading: 0
    }
  };
  const regions = [{
    name: 'Aisco EUROPE',
    value: 17,
    max: 20,
    percentage: 85
  }, {
    name: 'Aisco AMERICA',
    value: 4,
    max: 20,
    percentage: 20
  }, {
    name: 'Aisco ANZ',
    value: 1,
    max: 20,
    percentage: 5
  }];
  const dealers = [{
    name: 'Imper Regas Lda',
    count: 5,
    amount: '$225,896.83',
    missingPart: 0,
    pending: 0
  }, {
    name: 'KOAN IRRIGATION',
    count: 3,
    amount: '$175,432.21',
    missingPart: 0,
    pending: 0
  }, {
    name: 'VK SALES & SERVICE',
    count: 3,
    amount: '$157,890.45',
    missingPart: 0,
    pending: 0
  }, {
    name: 'AQUADOC',
    count: 3,
    amount: '$142,753.68',
    missingPart: 0,
    pending: 0
  }, {
    name: 'RIEGOS Y SISTEMAS JAIME BORREGO',
    count: 2,
    amount: '$98,567.32',
    missingPart: 0,
    pending: 0
  }, {
    name: 'SRL "AGROPROFI TECH"',
    count: 1,
    amount: '$76,432.19',
    missingPart: 0,
    pending: 0
  }];
  return <div className="space-y-6" data-id="element-1610">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1611">
        <DashboardCard className="md:col-span-2" icon={<TruckIcon size={20} className="text-blue-400" data-id="element-1613" />} title="Active Orders" subtitle="Current month" data-id="element-1612">
          <div className="flex flex-col" data-id="element-1614">
            <div className="text-4xl font-bold text-white mb-4" data-id="element-1615">
              {orderStats.value}
            </div>
            <div className="text-sm text-blue-300 mb-6" data-id="element-1616">
              Average margin: {orderStats.margin}
            </div>
            <div className="flex items-center justify-between mb-4" data-id="element-1617">
              <div className="flex items-center" data-id="element-1618">
                <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center mr-3" data-id="element-1619">
                  <span className="text-2xl font-bold text-blue-400" data-id="element-1620">
                    {orderStats.active}
                  </span>
                </div>
                <div className="text-sm" data-id="element-1621">
                  <div className="text-white font-medium" data-id="element-1622">Active orders</div>
                  <div className="text-blue-300" data-id="element-1623">Last updated today</div>
                </div>
              </div>
              <div className="flex items-center space-x-2" data-id="element-1624">
                <div className="px-3 py-1 rounded-full bg-blue-500/20 text-blue-300 text-sm" data-id="element-1625">
                  This Month
                </div>
                <div className="px-3 py-1 rounded-full bg-slate-800 text-blue-300 text-sm cursor-pointer hover:bg-slate-700" data-id="element-1626">
                  Last Month
                </div>
              </div>
            </div>
            <div className="h-40 relative" data-id="element-1627">
              <div className="absolute inset-x-0 bottom-0 flex items-end justify-between px-2" data-id="element-1628">
                {Array.from({
                length: 12
              }, (_, i) => <div key={i} className="flex flex-col items-center" data-id="element-1629">
                      <div className="w-8 bg-blue-500 rounded-t-sm" style={{
                  height: `${Math.random() * 100 + 20}px`
                }} data-id="element-1630"></div>
                      <div className="text-xs text-blue-300 mt-1" data-id="element-1631">
                        {new Date(0, i).toLocaleString('default', {
                    month: 'short'
                  })}
                      </div>
                    </div>)}
              </div>
            </div>
          </div>
        </DashboardCard>
        <DashboardCard icon={<ClockIcon size={20} className="text-amber-400" data-id="element-1633" />} title="Pending Status" data-id="element-1632">
          <div className="space-y-6" data-id="element-1634">
            <div className="grid grid-cols-3 gap-4" data-id="element-1635">
              <StatusItem value={orderStats.pending.approval} label="Approval" color="amber" data-id="element-1636" />
              <StatusItem value={orderStats.pending.acknowledgment} label="Acknowledgment" color="blue" data-id="element-1637" />
              <StatusItem value={orderStats.pending.stock} label="Stock" color="emerald" data-id="element-1638" />
            </div>
            <div className="grid grid-cols-2 gap-4" data-id="element-1639">
              <StatusBox icon={<WarehouseIcon size={18} className="text-blue-300" data-id="element-1641" />} value={orderStats.pending.readyToLoad} label="Ready to load" data-id="element-1640" />
              <StatusBox icon={<TruckIcon size={18} className="text-blue-300" data-id="element-1643" />} value={orderStats.pending.loading} label="Loading" data-id="element-1642" />
            </div>
          </div>
        </DashboardCard>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1644">
        <DashboardCard icon={<GlobeIcon size={20} className="text-blue-400" data-id="element-1646" />} title="Regional Distribution" className="md:col-span-3" data-id="element-1645">
          <div className="space-y-4" data-id="element-1647">
            {regions.map(region => <div key={region.name} className="space-y-2" data-id="element-1648">
                <div className="flex justify-between" data-id="element-1649">
                  <span className="text-sm text-blue-300" data-id="element-1650">{region.name}</span>
                  <span className="text-sm font-medium text-white" data-id="element-1651">
                    {region.value} orders
                  </span>
                </div>
                <div className="w-full bg-slate-700/50 rounded-full h-2.5 overflow-hidden" data-id="element-1652">
                  <div className="bg-blue-500 h-2.5 rounded-full" style={{
                width: `${region.percentage}%`
              }} data-id="element-1653"></div>
                </div>
                <div className="flex justify-between text-xs text-slate-400" data-id="element-1654">
                  <span data-id="element-1655">0</span>
                  <span data-id="element-1656">{region.max}</span>
                </div>
              </div>)}
          </div>
        </DashboardCard>
      </div>
      <DashboardCard icon={<BarChart3Icon size={20} className="text-blue-400" data-id="element-1658" />} title="Orders by Dealers" footer={<div className="flex justify-between text-sm text-blue-300" data-id="element-1659">
            <span data-id="element-1660">Showing 6 of 24 dealers</span>
            <button className="text-blue-400 hover:text-white" data-id="element-1661">View All</button>
          </div>} data-id="element-1657">
        <div className="flex justify-end mb-4" data-id="element-1662">
          <div className="flex items-center space-x-2" data-id="element-1663">
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1664">
              <ArrowUpDownIcon size={16} data-id="element-1665" />
            </button>
            <button className="p-2 rounded-lg bg-slate-800 text-blue-300 hover:bg-slate-700 transition-colors" data-id="element-1666">
              <FilterIcon size={16} data-id="element-1667" />
            </button>
            <div className="relative" data-id="element-1668">
              <select className="appearance-none bg-slate-800 text-blue-300 rounded-lg px-3 py-1.5 pr-8 text-sm border border-slate-700 focus:outline-none focus:ring-2 focus:ring-blue-500" data-id="element-1669">
                <option data-id="element-1670">Active orders</option>
                <option data-id="element-1671">All orders</option>
                <option data-id="element-1672">Completed orders</option>
              </select>
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-blue-300" data-id="element-1673">
                <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" data-id="element-1674">
                  <path d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" data-id="element-1675" />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-1676">
          <table className="w-full" data-id="element-1677">
            <thead data-id="element-1678">
              <tr className="text-left border-b border-slate-700" data-id="element-1679">
                <th className="pb-3 font-medium text-blue-300 text-sm" data-id="element-1680">
                  Dealer
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm" data-id="element-1681">
                  Status
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm text-right" data-id="element-1682">
                  Amount
                </th>
                <th className="pb-3 font-medium text-blue-300 text-sm text-right" data-id="element-1683">
                  Count
                </th>
              </tr>
            </thead>
            <tbody data-id="element-1684">
              {dealers.map((dealer, index) => <tr key={index} className="border-b border-slate-800/50 last:border-0 hover:bg-slate-800/30" data-id="element-1685">
                  <td className="py-3 text-white" data-id="element-1686">{dealer.name}</td>
                  <td className="py-3" data-id="element-1687">
                    {dealer.pending > 0 ? <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-amber-500/20 text-amber-300" data-id="element-1688">
                        <AlertCircleIcon size={12} className="mr-1" data-id="element-1689" />
                        {dealer.pending} pending
                      </div> : <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-emerald-500/20 text-emerald-300" data-id="element-1690">
                        <CheckCircleIcon size={12} className="mr-1" data-id="element-1691" />
                        Approved
                      </div>}
                  </td>
                  <td className="py-3 text-right text-blue-300" data-id="element-1692">
                    {dealer.amount}
                  </td>
                  <td className="py-3 text-right" data-id="element-1693">
                    <div className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-500/20 text-blue-300" data-id="element-1694">
                      {dealer.count}
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </DashboardCard>
    </div>;
}
function StatusItem({
  value,
  label,
  color
}) {
  const colors = {
    amber: 'text-amber-400',
    blue: 'text-blue-400',
    emerald: 'text-emerald-400'
  };
  return <div className="text-center" data-id="element-1695">
      <div className={`text-xl font-bold ${colors[color]} mb-1`} data-id="element-1696">{value}</div>
      <div className="text-xs text-blue-300" data-id="element-1697">{label}</div>
    </div>;
}
function StatusBox({
  icon,
  value,
  label
}) {
  return <div className="bg-slate-800/50 rounded-lg p-4 text-center" data-id="element-1698">
      <div className="flex justify-center mb-2" data-id="element-1699">
        <div className="p-2 rounded-lg bg-slate-700/50" data-id="element-1700">{icon}</div>
      </div>
      <div className="text-blue-300 text-xl font-bold mb-1" data-id="element-1701">{value}</div>
      <div className="text-xs text-blue-300" data-id="element-1702">{label}</div>
    </div>;
}